import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  AuditCompletedVerificationsResponse,
  AuditScreeningReviewResponse,
} from '../models/income-audit.models';
import { SupportIssueDefect } from 'src/app/issue-tracker/models/SupportIssue';

@Injectable({ providedIn: 'root' })
export class IncomeAuditService {
  constructor(private http: HttpClient) {}

  getDefectsForReviewIncome(issueTypeId: number): Observable<SupportIssueDefect[]> {
    return this.http.get<SupportIssueDefect[]>(
      `${environment.baseURl}/api/issues/defect-types/${issueTypeId}`
    );
  }

  getCompletedVerifications(
    page = 1,
    pageSize = 50,
    processorUserId?: number,
    dateFrom?: string,
    dateTo?: string
  ): Observable<AuditCompletedVerificationsResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());

    if (processorUserId) params = params.set('processorUserId', processorUserId.toString());
    if (dateFrom) params = params.set('dateFrom', dateFrom);
    if (dateTo) params = params.set('dateTo', dateTo);

    return this.http.get<AuditCompletedVerificationsResponse>(
      `${environment.baseURl}/api/income-audit/completed`,
      { params }
    );
  }

  getScreeningReview(screeningId: number): Observable<AuditScreeningReviewResponse> {
    return this.http.get<AuditScreeningReviewResponse>(
      `${environment.baseURl}/api/income-audit/review/${screeningId}`
    );
  }

  markScreeningAudited(screeningId: number, rating: string, notes?: string): Observable<unknown> {
    return this.http.post(
      `${environment.baseURl}/api/income-audit/mark-audited/${screeningId}`,
      { rating, notes: notes ?? null }
    );
  }

  createFinding(
    screeningId: number,
    draftSourceId: number,
    defectId: number,
    severity: number,
    description: string,
    assignedToUserId: number,
    expectedResolution?: string
  ): Observable<unknown> {
    return this.http.post(
      `${environment.baseURl}/api/income-audit/finding`,
      { screeningId, draftSourceId, defectId, severity, description, assignedToUserId, expectedResolution: expectedResolution ?? null }
    );
  }
}
